export const GROUP_SERVICE_AREA_STATE = {
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM',
  DISABLED: 'DISABLED',
};
